import {
  type PinDisplayProps,
  type Workflow,
  type WorkflowActionId,
  type WorkflowStageId,
  isDefined,
  isNotDefined,
  isNotEmpty,
} from '@terros/common'
import { ColorPrimitives } from '@front/model'
import { type IconEntry } from './useMaterialIconAtlas'

const EMPTY_STATE_COLOR = ColorPrimitives.neutral[300]
export const COMPANY_LOGO_IMAGE_SCALE = 1.25

type WorkflowStageIconAccount = {
  workflowStageId?: WorkflowStageId
  workflowActionId?: WorkflowActionId
}

/** Stage color plus the current action icon, matching area-management map pins. */
export function getWorkflowStageIconEntry(
  account: WorkflowStageIconAccount,
  workflow: Workflow,
  companyIconUrl: string | undefined
): IconEntry {
  const stage = isDefined(account.workflowStageId) ? workflow.getStage(account.workflowStageId) : undefined
  const color = stage?.color ?? EMPTY_STATE_COLOR

  if (stage?.useCompanyLogo && companyIconUrl) {
    return { color, imageUrl: companyIconUrl, imageScale: COMPANY_LOGO_IMAGE_SCALE }
  }

  const action = isDefined(account.workflowActionId) ? workflow.getAction(account.workflowActionId) : undefined
  return { color, icon: action?.icon }
}

export function toPinDisplayProps(entry: IconEntry): PinDisplayProps {
  if (isNotEmpty(entry.imageUrl)) return { type: 'logo', color: entry.color }
  if (isNotEmpty(entry.icon)) return { type: 'icon', color: entry.color, icon: entry.icon }
  return { type: 'icon', color: entry.color }
}

/** Same company image URL the area-management map pins use. */
export function toCompanyIconUrl(
  avatarUrl: string | undefined,
  avatarBlurhash: string | undefined
): string | undefined {
  if (isNotDefined(avatarUrl) || isNotDefined(avatarBlurhash)) return avatarUrl
  try {
    const url = new URL(avatarUrl)
    url.searchParams.set('bh', avatarBlurhash)
    return url.toString()
  } catch {
    return avatarUrl
  }
}
